import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutScreenCode extends Layout {
    panelScreenCodes: Panel;
    sourceScreenCodes: DataSource;
    textboxEdiStandardCode: Textbox;
    textboxFieldCode: Textbox;
    textboxFieldCodeDesc: Textbox;
    textboxFieldName: Textbox;
    textboxFieldTableAlias: Textbox;
}
